{
  "featuredEvent": "Événement à l'affiche",
  "upcomingEvents": "Événements à venir",
  "rsvp": "RSVP",
  "dateAtTime": "{{date}} à {{time}}",
  "dateRange": "{{start}} - {{end}}"
}
